var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            [
              _vm._l(_vm.states, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "col-xl-4 col-lg-6 mb-2 border-right",
                  },
                  [
                    _c("div", { staticClass: "row align-items-center" }, [
                      _vm._m(1, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-lg-8 d-flex align-items-center" },
                        [_c("h5", [_vm._v(_vm._s(item.name))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-lg-2 d-flex align-items-center" },
                        [
                          _c("v-switch", {
                            attrs: { "hide-details": "" },
                            model: {
                              value: item.notify,
                              callback: function ($$v) {
                                _vm.$set(item, "notify", $$v)
                              },
                              expression: "item.notify",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 mt-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success btn-sm",
                      on: {
                        click: function ($event) {
                          return _vm.SAVE()
                        },
                      },
                    },
                    [_vm._v("Guardar cambios")]
                  ),
                ]),
              ]),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h5", [_vm._v("Notificaciones")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Para habilitar tus notificaciones, habilita y guárda desde aquí"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-2" }, [
      _c(
        "div",
        {
          staticClass:
            "icon icon-shape rounded-3 bg-light text-dark text-lg me-4",
        },
        [_c("i", { staticClass: "bi bi-envelope" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }